import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { shouldEnableDarkMode } from '@helpers/dark-mode-helper';
import { HeaderProps } from '../../components/header/header.type';

interface Props {
	children: React.ReactNode;
	hideHeader?: boolean;
	hideFooter?: boolean;
	headerProps?: HeaderProps;
	mainLayoutStyle?: React.CSSProperties;
	innerWebStyle?: React.CSSProperties;
}

const Header = dynamic(async () => import('../../components/header'));
const Footer = dynamic(async () => import('../../components/footer'));

export const PageWrapper = ({
	children,
	hideHeader,
	hideFooter,
	headerProps,
	mainLayoutStyle,
	innerWebStyle
}: Props) => {
	const router = useRouter();
	const innerWebQP = Boolean(Number(router.query.innerweb));
	const darkModeQP = Boolean(Number(router.query.dark_mode));
	const isDarkModeEnabled = shouldEnableDarkMode(router.pathname, darkModeQP);

	return (
		<div
			className={`page-wrapper ${innerWebQP && 'inner-web'} ${
				isDarkModeEnabled ? 'dark-mode' : ''
			}`}
			style={innerWebQP ? innerWebStyle : null}
		>
			{hideHeader || innerWebQP ? null : <Header headerProps={headerProps} />}
			<div
				className={`main-layout ${
					innerWebQP || headerProps?.shouldStartTransparent ? '' : 'header-padding'
				}`}
				style={mainLayoutStyle}
			>
				{children}
			</div>
			{hideFooter || innerWebQP ? null : <Footer />}
		</div>
	);
};
